import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogOverlay, DialogTitle } from "@/components/ui/dialog"
import { useSelector } from "react-redux";
import { SET_COVER_GENERATE, SET_PLAYLIST } from "@/redux/features/music/playlistSlice";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { useState } from "react";
import axios from "axios";

const CoverGenerateDialog = () => {
    const { coverGenerateDialog } = useSelector((state) => state.playlists);
    const dispatch = useDispatch();
    const [customPrompt, setCustomPrompt] = useState("");
    const { playlists, selectedPlaylist } = useSelector((state) => state.playlists);

    // Regenerate playlist cover confirm
    const handleRegenerateConfirm = async (customPrompt) => {
        if (customPrompt.trim() === '') {
            toast.error("Custom prompt cannot be empty");
            return;
        }
        try {
            const token = localStorage.getItem("token");
            toast.loading("Generating playlist cover...", { id: "regenerate-loading" });
            const response = await axios.post("/playlist/regenerate-cover", {
                playlist_slug: selectedPlaylist.playlist_slug,
                custom_prompt: customPrompt,
            }, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const newCoverImageUrl = response.data.cover_url;
            // Update the specific playlist data in the array
            const updatedPlaylists = playlists.map(playlist => playlist.playlist_slug === selectedPlaylist.playlist_slug
                ? { ...playlist, cover_image: newCoverImageUrl } : playlist);
            dispatch(SET_PLAYLIST(updatedPlaylists));
            toast.dismiss("regenerate-loading");
            toast.success("Playlist cover regeneration successful");
            dispatch(SET_COVER_GENERATE(false));
        } catch (error) {
            console.error("Error regenerating playlist cover:", error);
            toast.dismiss("regenerate-loading");
            toast.error("Failed to regenerate playlist cover");
            dispatch(SET_COVER_GENERATE(false));
        }
    };

    return (
        <div>
            <Dialog open={coverGenerateDialog} onOpenChange={() => dispatch(SET_COVER_GENERATE(false))}>
                <DialogOverlay className="z-[99]">
                    <DialogContent className="z-[999] w-[90%] max-w-sm p-4 bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 dark:bg-gradient-to-br dark:from-pink-300 dark:via-pink-400 dark:to-pink-500 border dark:border-pink-800 rounded-lg shadow-2xl shadow-green-900/20">
                        <DialogHeader>
                            <DialogTitle className="text-xl text-green-400 dark:text-pink-900 font-normal font-potta">
                                Regenerate Playlist Cover
                            </DialogTitle>
                            <DialogDescription className="text-slate-300 dark:text-pink-800 text-sm">
                                Enter a custom prompt to generate a new cover image for your playlist
                            </DialogDescription>
                        </DialogHeader>
                        <div className="mt-4">
                            <textarea type="text" placeholder="Enter custom prompt (optional)" className="w-full p-2 rounded bg-slate-800 dark:bg-pink-300 text-slate-200 dark:text-slate-900 placeholder-slate-600 dark:placeholder-slate-900 focus:outline-none focus:ring-1 focus:ring-green-300/20 dark:focus:ring-pink-300" onChange={(e) => setCustomPrompt(e.target.value)} />
                        </div>
                        <DialogFooter className="flex flex-row gap-2 justify-end mt-4">
                            <Button variant="outline" onClick={() => dispatch(SET_COVER_GENERATE(false))} className="bg-slate-800 hover:bg-slate-700 text-slate-300 dark:bg-pink-300 dark:hover:bg-pink-300/70 dark:text-slate-900 dark:hover:text-slate-900 dark:border-pink-800">Cancel</Button>
                            <Button variant="outline" onClick={() => handleRegenerateConfirm(customPrompt)} className="bg-green-400 hover:bg-green-300 text-slate-700 dark:bg-pink-700 dark:hover:bg-pink-700/70 dark:text-white dark:hover:text-white dark:border-pink-800">Regenerate</Button>
                        </DialogFooter>
                    </DialogContent>
                </DialogOverlay>
            </Dialog>
        </div>
    )
}

export default CoverGenerateDialog
